/**
 * SciGrowth leads: loaded on every page (layout/theme.liquid).
 * 1. Saves ad click ids and UTM (last touch, 90 days) so they survive navigation to the form.
 * 2. Handles <form data-lead-form>: prefill from ?service=, validate, send to the Worker,
 *    fire the browser Lead event with the same event id (deduplicated by Meta), show the thank-you message (brief link arrives by email).
 */
(function () {
  // Fill in after deploying the Worker and creating the Cal.com event.
  var CFG = {
    endpoint: 'https://capi-scigrowth.old-resonance-e063.workers.dev/lead',
    storagePrefix: 'scigrowth'
  };

  var STORE_KEY = CFG.storagePrefix + '_click_ids';
  var MAX_AGE_DAYS = 90;
  var PARAMS = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function readStore() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (raw && Date.now() - raw.t < MAX_AGE_DAYS * 864e5) return raw.v || {};
    } catch (e) {}
    return {};
  }

  function captureFromUrl() {
    var qs = new URLSearchParams(location.search);
    var found = {}, any = false;
    PARAMS.forEach(function (p) {
      var val = qs.get(p);
      if (val) { found[p] = val; any = true; }
    });
    if (any) { try { localStorage.setItem(STORE_KEY, JSON.stringify({ t: Date.now(), v: found })); } catch (e) {} }
  }

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'id-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function prefill(form) {
    var wanted = new URLSearchParams(location.search).get('service');
    if (!wanted) return;
    wanted = wanted.replace(/"/g, '');
    var boxes = form.querySelectorAll('input[name="service_opt"]');
    for (var i = 0; i < boxes.length; i++) {
      if ((boxes[i].getAttribute('data-handles') || '').split(',').indexOf(wanted) !== -1) { boxes[i].checked = true; return; }
    }
  }

  // "Not sure" and the real services exclude each other.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'service_opt' || !t.checked) return;
    var boxes = t.form.querySelectorAll('input[name="service_opt"]');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i] !== t && boxes[i].hasAttribute('data-exclusive') !== t.hasAttribute('data-exclusive')) boxes[i].checked = false;
    }
    var grp = t.closest('[data-lead-services]');
    if (grp) grp.classList.remove('is-invalid');
  }, true);

  function showError(form, msg) {
    var el = form.querySelector('[data-lead-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  function showDone(section, form) {
    form.hidden = true;
    var done = section.querySelector('[data-lead-done]');
    if (!done) return;
    done.hidden = false;
    done.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function onSubmit(ev) {
    var form = ev.target;
    if (!form.matches || !form.matches('[data-lead-form]')) return;
    ev.preventDefault();

    var section = form.closest('[data-lead-section]') || form;
    showError(form, '');
    var bad = false;
    form.querySelectorAll('[required]').forEach(function (el) {
      var ok = el.type === 'checkbox' ? el.checked : (el.value.trim() && (el.type !== 'email' || /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(el.value.trim())));
      el.classList.toggle('is-invalid', !ok);
      if (!ok) bad = true;
    });
    var services = [].slice.call(form.querySelectorAll('input[name="service_opt"]:checked')).map(function (el) { return el.value; });
    var grp = form.querySelector('[data-lead-services]');
    if (grp) { grp.classList.toggle('is-invalid', !services.length); if (!services.length) bad = true; }
    if (bad) { showError(form, 'Please fill in the highlighted fields and accept the Privacy Policy.'); return; }
    if (!CFG.endpoint) { showError(form, 'The form is not connected yet. Please email info@scigrowth.com.'); return; }

    var v = function (n) { var el = form.elements[n]; return el ? el.value.trim() : ''; };
    var ids = readStore();
    var payload = {
      event_name: 'Lead',
      event_id: uuid(),
      event_source_url: location.href,
      fbp: cookie('_fbp'),
      fbc: cookie('_fbc'),
      name: v('name'), email: v('email'), phone: v('phone'),
      service: services.join(', '), niche: v('niche'), budget: v('budget'),
      website_url: v('website_url'), timeline: v('timeline'), message: v('message'),
      privacy_accepted: form.elements.privacy && form.elements.privacy.checked ? 'Yes' : 'No',
      marketing_consent: form.elements.marketing && form.elements.marketing.checked ? 'Yes' : 'No',
      form_type: section.getAttribute('data-form-type') || '',
      website: v('website') // honeypot
    };
    PARAMS.forEach(function (p) { if (ids[p]) payload[p] = ids[p]; });

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    fetch(CFG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('http_' + res.status);
      return res.json();
    }).then(function (out) {
      if (!out || !out.ok) throw new Error('rejected');
      // Count the lead only after the server accepted it. Same event id as the server event.
      try { if (window.fbq) fbq('track', 'Lead', {}, { eventID: payload.event_id }); } catch (e) {}
      try { if (window.gtag) gtag('event', 'generate_lead', { event_id: payload.event_id }); } catch (e) {}
      showDone(section, form);
    }).catch(function () {
      if (btn) btn.disabled = false;
      showError(form, 'Something went wrong. Please try again or email info@scigrowth.com.');
    });
  }

  // Clear the red highlight as soon as the visitor fixes a field.
  document.addEventListener('input', function (e) { if (e.target && e.target.classList) e.target.classList.remove('is-invalid'); }, true);
  document.addEventListener('change', function (e) { if (e.target && e.target.classList) e.target.classList.remove('is-invalid'); }, true);

  captureFromUrl();
  document.addEventListener('submit', onSubmit, true);
  document.querySelectorAll('[data-lead-form]').forEach(prefill);
})();
